module.exports = __webpack_public_path__ + "sansg/img/12.9c60a252.png";